import React from 'react';
import PropTypes from 'prop-types';
import s from './MLLabel.module.css';

function MLLabel(props) {
  const {
    label,
    className,
  } = props;

  const classes = className ? `${s.MLLabel} ${className}` : s.MLLabel;
  return (
    <label className={classes} htmlFor={name}>{label}</label>
  );
}

MLLabel.propTypes = {
  label: PropTypes.string,
  className: PropTypes.string,
};

export default MLLabel;
